/**
 * German display labels for Spitex enum values.
 * Used by form renderers and email templates to show human-readable text.
 */

export const qualificationLabels: Record<string, string> = {
  hf_pflege: 'Dipl. Pflegefachperson HF',
  fh_pflege: 'BSc Pflege FH',
  fage: 'Fachfrau/-mann Gesundheit FaGe',
  fabe: 'Fachperson Betreuung FaBe',
  ags: 'Assistent/in Gesundheit und Soziales AGS',
  pflegehilfe_srk: 'Pflegehilfe SRK',
  physiotherapist: 'Physiotherapeut/in',
  occupational_therapist: 'Ergotherapeut/in',
  midwife: 'Hebamme',
  no_qualification: 'Ohne Fachausbildung',
  other: 'Andere',
};

export const serviceInterestLabels: Record<string, string> = {
  angehoerigenpflege: 'Angehoerigenpflege',
  betreuung: 'Betreuung',
  hauswirtschaft: 'Hauswirtschaft',
};

export const medizinischeAusbildungLabels: Record<string, string> = {
  ja_abgeschlossen: 'Ja, abgeschlossen',
  in_ausbildung: 'In Ausbildung',
  nein: 'Keine',
};

export const careTypeLabels: Record<string, string> = {
  personal_care: 'Grundpflege',
  medical_care: 'Medizinische Pflege',
  household_help: 'Hauswirtschaftliche Hilfe',
  companionship: 'Begleitdienst',
  palliative: 'Palliative Pflege',
  post_hospital: 'Pflege nach Spitalaufenthalt',
  respite_care: 'Entlastungspflege',
  child_care: 'Kinderspitex',
  angehoerigenpflege: 'Angehoerigenpflege',
  acute_transitional: 'Akut- und Uebergangspflege',
};

export const cantonLabels: Record<string, string> = {
  AG: 'Aargau',
  AI: 'Appenzell Innerrhoden',
  AR: 'Appenzell Ausserrhoden',
  BE: 'Bern',
  BL: 'Basel-Landschaft',
  BS: 'Basel-Stadt',
  FR: 'Fribourg',
  GE: 'Geneve',
  GL: 'Glarus',
  GR: 'Graubuenden',
  JU: 'Jura',
  LU: 'Luzern',
  NE: 'Neuchatel',
  NW: 'Nidwalden',
  OW: 'Obwalden',
  SG: 'St. Gallen',
  SH: 'Schaffhausen',
  SO: 'Solothurn',
  SZ: 'Schwyz',
  TG: 'Thurgau',
  TI: 'Ticino',
  UR: 'Uri',
  VD: 'Vaud',
  VS: 'Wallis',
  ZG: 'Zug',
  ZH: 'Zuerich',
};

export const availabilityLabels: Record<string, string> = {
  full_time: 'Vollzeit',
  part_time: 'Teilzeit',
  on_call: 'Auf Abruf',
  weekends_only: 'Nur Wochenende',
  flexible: 'Flexibel',
};

export const referralSourceLabels: Record<string, string> = {
  google_search: 'Google Suche',
  opan: 'OPAN (Spitalueberweisung)',
  hospital_referral: 'Spitalueberweisung',
  gp_referral: 'Hausarzt-Ueberweisung',
  municipal_referral: 'Gemeinde',
  word_of_mouth: 'Empfehlung',
  comparis: 'Comparis',
  other: 'Andere',
};

export const specializationLabels: Record<string, string> = {
  geriatric_care: 'Geriatrische Pflege',
  palliative_care: 'Palliative Care',
  dementia_care: 'Demenzpflege',
  wound_care: 'Wundversorgung',
  pediatric_home_care: 'Paediatrische Pflege',
  psychiatric_care: 'Psychiatrische Pflege',
  rehabilitation: 'Rehabilitation',
  diabetes_management: 'Diabetesberatung',
  post_surgical: 'Postoperative Pflege',
  maternity: 'Wochenbett-/Mutterpflege',
};
